var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3333 9.66667C13.5985 9.66667 13.8529 9.77202 14.0404 9.95956C14.228 10.1471 14.3333 10.4015 14.3333 10.6667V13.3333C14.3333 13.7754 14.1577 14.1993 13.8452 14.5118C13.5326 14.8244 13.1087 15 12.6667 15H3.33333C2.89131 15 2.46738 14.8244 2.15482 14.5118C1.84226 14.1993 1.66667 13.7754 1.66667 13.3333V10.6667C1.66667 10.4015 1.77202 10.1471 1.95956 9.95956C2.1471 9.77202 2.40145 9.66667 2.66667 9.66667C2.93188 9.66667 3.18624 9.77202 3.37377 9.95956C3.56131 10.1471 3.66667 10.4015 3.66667 10.6667V13H12.3333V10.6667C12.3333 10.4015 12.4387 10.1471 12.6262 9.95956C12.8138 9.77202 13.0681 9.66667 13.3333 9.66667ZM8 1C8.26522 1 8.51957 1.10536 8.70711 1.29289C8.89464 1.48043 9 1.73478 9 2V8.024L10.1213 6.90267C10.3105 6.72368 10.562 6.62553 10.8223 6.62909C11.0827 6.63265 11.3314 6.73764 11.5156 6.92173C11.6998 7.10582 11.8049 7.35448 11.8086 7.61486C11.8123 7.87524 11.7142 8.12678 11.5353 8.316L8.82467 11.0273C8.6059 11.2459 8.30928 11.3688 8 11.3688C7.69072 11.3688 7.3941 11.2459 7.17533 11.0273L4.46467 8.31667C4.28251 8.12806 4.18171 7.87546 4.18399 7.61327C4.18627 7.35107 4.29144 7.10026 4.47685 6.91485C4.66226 6.72944 4.91307 6.62427 5.17527 6.62199C5.43746 6.61971 5.69006 6.72051 5.87867 6.90267L7 8.024V2C7 1.73478 7.10536 1.48043 7.29289 1.29289C7.48043 1.10536 7.73478 1 8 1Z",
    fill: "var(--fill-0, #185DD8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2Fill);
export default __webpack_public_path__ + "static/media/download_2_fill.745302bdb45dc551c6a8c4ee2568df71.svg";
export { ForwardRef as ReactComponent };